import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21cdca4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-exam-body-container" }
const _hoisted_2 = {
  key: 0,
  class: "object-container"
}
const _hoisted_3 = { class: "left-container" }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { class: "left-container-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("上一题")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("下一题")
const _hoisted_8 = { class: "more-tip" }
const _hoisted_9 = { class: "right-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sheet-title" }, "答题卡", -1))
const _hoisted_11 = { class: "question-menu-container" }
const _hoisted_12 = { class: "ide-container" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "iframe-saving-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionTypeHeader = _resolveComponent("QuestionTypeHeader")!
  const _component_QuestionProgram = _resolveComponent("QuestionProgram")!
  const _component_QuestionChoice = _resolveComponent("QuestionChoice")!
  const _component_QuestionFillBlank = _resolveComponent("QuestionFillBlank")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_UserInfoCard = _resolveComponent("UserInfoCard")!
  const _component_QuestionMenu = _resolveComponent("QuestionMenu")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.questionService.showIde)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_QuestionTypeHeader, {
              questionTypeId: _ctx.questionService.question.questionTypeId,
              index: _ctx.questionService.currentIndex,
              totalNum: _ctx.questionService.currentQuestionType.questionDtoList.length,
              totalScore: _ctx.questionService.currentQuestionType.questionsTotalScore
            }, null, 8, ["questionTypeId", "index", "totalNum", "totalScore"]),
            _createElementVNode("div", {
              class: "main-content",
              ref: "mainContentRef",
              onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateShowMoreTipDebounce && _ctx.updateShowMoreTipDebounce(...args)))
            }, [
              (_ctx.questionService.isProgram)
                ? (_openBlock(), _createBlock(_component_QuestionProgram, {
                    key: _ctx.questionService.question.id,
                    question: _ctx.questionService.question,
                    answerMode: _ctx.examService.answerMode,
                    hasPaperAnswer: _ctx.examService.hasPaperAnswerRecord,
                    markRecordData: _ctx.questionService.currentQuestionMarkRecordTableData,
                    onShow: _ctx.questionService.showIdeEvent
                  }, null, 8, ["question", "answerMode", "hasPaperAnswer", "markRecordData", "onShow"]))
                : (_ctx.questionService.isChoice)
                  ? (_openBlock(), _createBlock(_component_QuestionChoice, {
                      key: _ctx.questionService.question?.id,
                      question: _ctx.questionService.question,
                      answerMode: _ctx.examService.answerMode,
                      currentPaperAnswer: _ctx.questionService.currentQuestionPaperAnswer,
                      onChange: _ctx.onChoiceChange
                    }, null, 8, ["question", "answerMode", "currentPaperAnswer", "onChange"]))
                  : (_ctx.questionService.isFillBlank)
                    ? (_openBlock(), _createBlock(_component_QuestionFillBlank, {
                        key: _ctx.questionService.question?.id + '',
                        question: _ctx.questionService.question,
                        answerMode: _ctx.examService.answerMode,
                        currentPaperAnswer: _ctx.questionService.currentQuestionPaperAnswer,
                        onChange: _ctx.onInputChange
                      }, null, 8, ["question", "answerMode", "currentPaperAnswer", "onChange"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, "不支持当前提题型"))
            ], 544),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_button, {
                type: "default",
                shape: "round",
                size: "large",
                class: "btn-nav-question",
                disabled: _ctx.questionService.isFirstQuestion,
                onClick: _ctx.questionService.goToPrevQuestion
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                shape: "round",
                size: "large",
                class: "btn-nav-question",
                disabled: _ctx.questionService.isLastQuestion,
                onClick: _ctx.questionService.goToNextQuestion
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_8, "下滑查看更多", 512), [
                    [_vShow, _ctx.showMoreTip]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.examService.userInfo4Exam)
              ? (_openBlock(), _createBlock(_component_UserInfoCard, {
                  key: 0,
                  avatar: _ctx.examService.userInfo4Exam.userAvatar,
                  name: _ctx.examService.userInfo4Exam.userName,
                  sex: _ctx.examService.userInfo4Exam.sex,
                  grade: _ctx.examService.userInfo4Exam.grade
                }, null, 8, ["avatar", "name", "sex", "grade"]))
              : _createCommentVNode("", true),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_QuestionMenu, {
                list: _ctx.examService.exam.questionsDtoList,
                selectQuestion: _ctx.questionService.selectQuestion
              }, null, 8, ["list", "selectQuestion"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.questionService.firstTimeShowIde)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            ref: "ideIframeRef",
            src: _ctx.questionService.ideIframeUrl,
            width: "100%",
            height: "100%",
            frameborder: "0",
            title: "",
            allow: "camera; microphone",
            onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onIdeIframeLoaded && _ctx.onIdeIframeLoaded(...args)))
          }, null, 40, _hoisted_13))
        : _createCommentVNode("", true),
      (_ctx.questionService.isProgram && _ctx.questionService.ideIframeSaving)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_a_spin, {
              style: {"height":"100%"},
              size: "large",
              tip: "正在全力保存IDE数据中..."
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}